import { render, staticRenderFns } from "./pelamarKerjaDitolak.vue?vue&type=template&id=61ebfa2a"
import script from "./pelamarKerjaDitolak.vue?vue&type=script&lang=js"
export * from "./pelamarKerjaDitolak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports